import "./styles.css";
import logoSrc from "../../assets/images/logo.svg";

export default function MaintenanceModePage(): JSX.Element {
    return (
        <body className="maintenance">
            <main
                className="maintenance__content"
                role="status"
                aria-live="polite"
            >
                <img
                    className="maintenance__logo"
                    alt="Logo Prelib"
                    src={logoSrc}
                />

                <h1 className="maintenance__title">
                    Le portail patient est en maintenance
                </h1>
                <p className="maintenance__text">
                    De retour dans quelques minutes.
                </p>

                <hr className="maintenance__divider" />

                <h2 className="maintenance__title">
                    The patient portal is under maintenance
                </h2>
                <p className="maintenance__text">Back in a few minutes.</p>

                <p className="maintenance__text">
                    Questions?{" "}
                    <a
                        className="maintenance__support-link"
                        href="mailto:support@prelib.com"
                    >
                        support@prelib.com
                    </a>
                </p>
            </main>
        </body>
    );
}
